import React from 'react';

import { SplitCarousel } from '../../components/SplitCarousel/SplitCarousel';
import type { Step } from './slides';

import './HowItWorksSection.css';

type HowItWorksSectionProps = {
    steps: Step[];
};

export function HowItWorksSection({ steps }: HowItWorksSectionProps) {
    return (
        <section className="fa-steps">
            <SplitCarousel<Step>
                slides={steps}
                classPrefix="fa-steps"
                previousLabel="Previous step"
                nextLabel="Next step"
                dotLabel={(i) => `Go to step ${i + 1}`}
                arrowFocusColor="var(--faves-accent)"
                dotColor="var(--faves-accent)"
                renderVisual={(step) => (
                    <img
                        src={step.visual.image}
                        alt=""
                        className="fa-steps__visual-img"
                        aria-hidden="true"
                        loading="lazy"
                        decoding="async"
                    />
                )}
                renderText={(step, i) => (
                    <React.Fragment>
                        <span className="fa-steps__eyebrow faves-eyebrow" key={`eyebrow-${i}`}>{step.step}</span>
                        <div className="fa-steps__copy" key={`copy-${i}`}>
                            <h2 className="fa-steps__heading faves-display">{step.heading}</h2>
                            <p className="fa-steps__body faves-body">{step.body}</p>
                        </div>
                    </React.Fragment>
                )}
            />
        </section>
    );
}
